import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  linkText: {
    color: theme.palette.select.light,
    display: 'contents',
    cursor: 'pointer',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  modalDescription: {
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  awsImg: {
    height: theme.spacing(5),
    width: theme.spacing(5),
  },
  modalContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(-2),
  },
  modalContent: {
    color: theme.palette.labraText.tertiary,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
  },
  modalLinkContainer: {
    marginTop: theme.spacing(1),
  },
  customFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(4),
  },
  customFieldTitle: {
    paddingTop: theme.spacing(2.5),
  },
  customField: {
    paddingTop: theme.spacing(1.5),
  },
  row: {
    display: 'flex',
    padding: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1.1),
    alignSelf: 'stretch',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.dividerV2.main}`,
  },
  icon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    objectFit: 'contain',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  titleAndIcon: {
    width: '100%',
    display: 'flex',
    position: 'relative',
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    color: '#381E1C !important',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: 0.15,
  },
  headingSub: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: 0.25,
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))
